import React from 'react'
import { View } from 'styles/reactnative'

import { Button, Input, Popover, Select, Space } from 'antd'
import TableAPI from '../../../components/TableAPI'
import { CloseOutlined, SearchOutlined } from '@ant-design/icons'
import { column_walletlist_page } from '../../../components/AdminUserModal/UserInfoTabs/column_walletlist_page'
import { useUserList } from '../../../hooks/user/userlist'
import { useUserGroup } from '../../../hooks/user/usergroups'
import { column_ip_list } from '../../../components/AdminUserModal/UserInfoTabs/column_iplist'

const AdminIPList = ({ title, type }: any) => {
	const queryParams = new URLSearchParams(window.location.search)
	const id = queryParams.get('userid')

	const [search, setSearch] = React.useState(id || '')
	const [wallettype, setWalletType] = React.useState('9')

	const { usertype1 } = useUserList()
	const [group, setGroup] = React.useState('*')
	const { type1 } = useUserGroup()

	return (
		<View style={{ width: '100%' }}>
			<View
				style={{
					flexDirection: 'row',
					backgroundColor: 'white',
					width: '100%',
					padding: 10,
					marginTop: 10,
					borderTopLeftRadius: 10,
					borderTopRightRadius: 10,
				}}>

				<Space.Compact direction="horizontal">
					<Input
						placeholder="검색"
						value={search}
						onChange={e => {
							setSearch(e.target.value)
						}}
					/>
					<Button
						onClick={() => {
							setSearch('')
						}}
						style={{ paddingTop: 0 }}
						size="small">
						{search ? <CloseOutlined /> : <SearchOutlined />}
					</Button>
				</Space.Compact>
			</View>
			<TableAPI
				title={title}
				columns={column_ip_list}
				usermodal={true}
				height={'default'}
				apikey={`/admin/userip?searchip=${search}`}
			/>
		</View>
	)
}

export default React.memo(AdminIPList)
